import Lottie from 'lottie-react'

import gustoLoading from '@/assets/lottie/gustoLoading.json'
import { Dialog, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const PayrollLoading = ({
  text,
  subtext,
}: {
  text: string
  subtext?: string
}) => (
  <Dialog open>
    <Dialog.Content>
      <Lottie animationData={gustoLoading} loop />
      <div className="text-wrapper">
        <Text variant={TypographyStyles.H1} color={TextColors.WHITE}>
          {text}
        </Text>
        <br />
        <Text variant={TypographyStyles.H3} color={TextColors.WHITE}>
          {subtext}
        </Text>
      </div>
    </Dialog.Content>
  </Dialog>
)
